import { combineReducers } from 'redux';

import configReducer from './config';
import authReducer from './auth';
import quizReducer from './quiz';
import quizBuilderReducer from './quiz_builder';
import folderReducer from './folder';
import tagReducer from './tag';
import categoryReducer from './category';
import userReducer from './user';
import quizSessionReducer from './quiz_session';

const rootReducer = combineReducers({
  ...configReducer,
  ...authReducer,
  ...quizReducer,
  ...quizBuilderReducer,
  ...folderReducer,
  ...tagReducer,
  ...categoryReducer,
  ...userReducer,
  ...quizSessionReducer,
});

export default rootReducer;
